<template>  
    <div :style="shu.yangshi" class="zidingyi_wenzi">lunkuo</div> 	
</template>

<script>
export default {
  name: 'lunkuo',
  props: {
       shu: {
		   type:Object,
		   default(){
			   return {wenzi:'输入文字',yangshi:{}}
		   }
		}
  },
  
}
</script>



